'use client';

import SignoutIcon from '@/components/icons/signout-icon';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { clearAuthCookies } from '@/lib/actions/customer/action';

export default function ButtonLogout() {
  const handleLogout = async () => {
    sessionStorage.setItem('manual_logout', 'true');

    await clearAuthCookies();
    await fetch('/api/remove-cart-cookie', { method: 'GET' });

    window.location.href = '/';
  };
  return (
    <DropdownMenuItem onClick={handleLogout} className='text-red-500 hover:text-red-500'>
      <SignoutIcon color='red' className='mr-2 h-4 w-4' /> Sign Out
    </DropdownMenuItem>
  );
}
